// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  listSqlRoleAssignments,
  deleteSqlRoleAssignment,
  createUpdateSqlRoleAssignment,
  getSqlRoleAssignment,
  listSqlRoleDefinitions,
  deleteSqlRoleDefinition,
  createUpdateSqlRoleDefinition,
  getSqlRoleDefinition,
  listSqlTriggers,
  deleteSqlTrigger,
  createUpdateSqlTrigger,
  getSqlTrigger,
  listSqlUserDefinedFunctions,
  deleteSqlUserDefinedFunction,
  createUpdateSqlUserDefinedFunction,
  getSqlUserDefinedFunction,
  listSqlStoredProcedures,
  deleteSqlStoredProcedure,
  createUpdateSqlStoredProcedure,
  getSqlStoredProcedure,
  retrieveContinuousBackupInformation,
  listSqlContainers,
  deleteSqlContainer,
  createUpdateSqlContainer,
  getSqlContainer,
  listClientEncryptionKeys,
  createUpdateClientEncryptionKey,
  getClientEncryptionKey,
  migrateSqlContainerToManualThroughput,
  migrateSqlContainerToAutoscale,
  updateSqlContainerThroughput,
  getSqlContainerThroughput,
  migrateSqlDatabaseToManualThroughput,
  migrateSqlDatabaseToAutoscale,
  updateSqlDatabaseThroughput,
  getSqlDatabaseThroughput,
  listSqlDatabases,
  deleteSqlDatabase,
  createUpdateSqlDatabase,
  getSqlDatabase,
} from "./operations.js";
export type {
  SqlResourcesListSqlRoleAssignmentsOptionalParams,
  SqlResourcesDeleteSqlRoleAssignmentOptionalParams,
  SqlResourcesCreateUpdateSqlRoleAssignmentOptionalParams,
  SqlResourcesGetSqlRoleAssignmentOptionalParams,
  SqlResourcesListSqlRoleDefinitionsOptionalParams,
  SqlResourcesDeleteSqlRoleDefinitionOptionalParams,
  SqlResourcesCreateUpdateSqlRoleDefinitionOptionalParams,
  SqlResourcesGetSqlRoleDefinitionOptionalParams,
  SqlResourcesListSqlTriggersOptionalParams,
  SqlResourcesDeleteSqlTriggerOptionalParams,
  SqlResourcesCreateUpdateSqlTriggerOptionalParams,
  SqlResourcesGetSqlTriggerOptionalParams,
  SqlResourcesListSqlUserDefinedFunctionsOptionalParams,
  SqlResourcesDeleteSqlUserDefinedFunctionOptionalParams,
  SqlResourcesCreateUpdateSqlUserDefinedFunctionOptionalParams,
  SqlResourcesGetSqlUserDefinedFunctionOptionalParams,
  SqlResourcesListSqlStoredProceduresOptionalParams,
  SqlResourcesDeleteSqlStoredProcedureOptionalParams,
  SqlResourcesCreateUpdateSqlStoredProcedureOptionalParams,
  SqlResourcesGetSqlStoredProcedureOptionalParams,
  SqlResourcesRetrieveContinuousBackupInformationOptionalParams,
  SqlResourcesListSqlContainersOptionalParams,
  SqlResourcesDeleteSqlContainerOptionalParams,
  SqlResourcesCreateUpdateSqlContainerOptionalParams,
  SqlResourcesGetSqlContainerOptionalParams,
  SqlResourcesListClientEncryptionKeysOptionalParams,
  SqlResourcesCreateUpdateClientEncryptionKeyOptionalParams,
  SqlResourcesGetClientEncryptionKeyOptionalParams,
  SqlResourcesMigrateSqlContainerToManualThroughputOptionalParams,
  SqlResourcesMigrateSqlContainerToAutoscaleOptionalParams,
  SqlResourcesUpdateSqlContainerThroughputOptionalParams,
  SqlResourcesGetSqlContainerThroughputOptionalParams,
  SqlResourcesMigrateSqlDatabaseToManualThroughputOptionalParams,
  SqlResourcesMigrateSqlDatabaseToAutoscaleOptionalParams,
  SqlResourcesUpdateSqlDatabaseThroughputOptionalParams,
  SqlResourcesGetSqlDatabaseThroughputOptionalParams,
  SqlResourcesListSqlDatabasesOptionalParams,
  SqlResourcesDeleteSqlDatabaseOptionalParams,
  SqlResourcesCreateUpdateSqlDatabaseOptionalParams,
  SqlResourcesGetSqlDatabaseOptionalParams,
} from "./options.js";
